/// <reference types="@types/googlemaps" />
import { OrganizationOption } from "src/app/services/organization.service";
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  OnDestroy,
  OnInit,
  Output,
  SecurityContext,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import {
  FormGroup,
  FormControl,
  Validators,
  NgForm,
  ValidationErrors,
  FormArray,
  AbstractControl,
} from "@angular/forms";
import { fadeInUp400ms } from "../../@vex/animations/fade-in-up.animation";
import { stagger60ms } from "../../@vex/animations/stagger.animation";
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions,
} from "@angular/material/form-field";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { AuthService } from "src/app/pages/auth/authServices";
import { GoogleUrlService } from "src/app/services/google-url.service";
import {
  combineLatest,
  firstValueFrom,
  merge,
  Observable,
  Subscription,
} from "rxjs";
import { Location } from "@angular/common";
import { MatDialog } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { SafeResourceUrl, DomSanitizer } from "@angular/platform-browser";
import { PDFDocument } from "pdf-lib";
import { CalendarService } from "../pages/calendar/calendar.service";
import { ReportsService } from "../pages/reports/reports.service";
import { DialogService } from "../pages/confirm-dialog-box/confir-dialog-box.service";
import { BodyPartsComponent } from "./body-parts/body-parts.component";
import { STATES } from "../pages/state";
import { DemoService } from "./demo.service";
import { ConfigService } from "../services/config.service";
export interface PlaceSearchResult {
  address: string;
  imageUrl?: string;
  location?: google.maps.LatLng;
  iconUrl?: string;
  name?: string;
}

@Component({
  selector: "vex-demo",
  templateUrl: "./demo.component.html",
  styleUrls: ["./demo.component.scss"],
  animations: [fadeInUp400ms, stagger60ms],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: "standard",
      } as MatFormFieldDefaultOptions,
    },
  ],
})
export class DemoComponent {
  isRecaptchaVerified: boolean = false;
  deuData: any;
  onRecaptchaResolved(captchaResponse: string): void {
    if (captchaResponse) {
      this.isRecaptchaVerified = true;
    }
  }

  isMobile = window.innerWidth < 768;

  @HostListener("window:resize", ["$event"])
  onResize() {
    this.isMobile = window.innerWidth < 768;
  }
  pdfBytes: Uint8Array | undefined;
  displayedColumns: string[] = ["recipient", "mode", "pdfURL"];
  wcabSelection: string = "None Provided";
  isCustomWCAB: boolean = false;

  requestingParties: string[] = [
    "Applicant Attorney",
    "Defense Attorney",
    "Applicant",
    "Adjuster",
    "Employer",
  ];
  claimNumberSelection: string = "None Provided";
  isCustomClaimNumber: boolean = false;
  states = STATES;

  @ViewChild("pdfDialogTemplate") pdfDialogTemplate!: TemplateRef<any>;

  @ViewChild("inputField") inputField!: ElementRef<HTMLInputElement>;
  @ViewChild("fileInputStrikePanel") fileInputStrikePanel: any;
  @ViewChild("fileInputAttorneyDemos") fileInputAttorneyDemos: any;
  autocomplete: google.maps.places.Autocomplete | undefined;
  @Output() placeChanged = new EventEmitter<PlaceSearchResult>();
  BaseFileURL: string;
  languages: string[] = [
    "Spanish",
    "Portuguese",
    "English",
    "German",
    "Italian",
    "Arabic",
    "Chinese",
    "Ukrainian",
    "Japanese",
    "Dutch",
    "French",
  ];
  form: FormGroup;
  isDraft: any = "false";
  applicants: any[] = [];
  filteredApplicants: any[] = [];
  attorneys: any[] = [];
  filteredApplicantAttorney: any[] = [];
  insuracneCompany: any[] = [];
  filteredInsurance: any[] = [];
  filteredFirmAttorney: any[] = [];
  filtereddefenseAttorney: any[] = [];
  public mode = "add";
  isSubmitting = false;
  physicians: any[] = [];
  organizations: OrganizationOption[] = [];
  private organizationPhysicians: any[] = [];
  isCustomLanguage: boolean;
  customLanguageControl: FormControl = new FormControl("");
  private subscriptions: Subscription[] = [];
  private ID: string;
  private authStatusSub: Subscription;
  isLoading = false;
  imagePreview: string | ArrayBuffer;
  roleSub: Subscription;
  numRegex = /^-?\d*[.,]?\d{0,4}$/;
  @ViewChild("formDirective") private formDirective: NgForm;
  existingStrikePanelFiles: any[] = [];
  existingAttorneyDemoFiles: any[] = [];
  pdfUrl: any | SafeResourceUrl;
  recipients: any;
  isSubmitting2: boolean;
  isSubmitting3: boolean;
  startDate: any;
  endDate: any;
  dateTimeRange: any;
  c: any;
  status: any;
  status2: any;
  status3: any;
  status5: any;

  clinics: any;
  status4: string;
  isReqForm: any;
  dateOfAppointment: any;
  applicantDigitalService: any;
  applicantAttorneyDigitalService: any;
  defenseDigitalService: any;
  employerDigitalService: any;
  insuranceDigitalService: any;
  isDraftSave: boolean;
  maxDate: Date = new Date();
  minDate: Date = new Date();
  isSubmitting4: boolean;
  showPreviousEncounter: boolean;
  previousEncounterLength: number;
  isDragOver: boolean;
  isDragOver_2: boolean;
  rescheduled: any;
  constructor(
    private authService: AuthService,
    private googleUrlService: GoogleUrlService,
    public route: ActivatedRoute,
    private location: Location,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private calendarService: CalendarService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private reportsService: ReportsService,
    private dialog2: DialogService,
    private demoService: DemoService,
    private configService: ConfigService,
  ) {}

  ngOnInit(): void {
    this.BaseFileURL = this.configService.get('fileURL');
    this.isLoading = true;
    this.authStatusSub = this.authService
      .getAuthStatusListener()
      .subscribe((authStatus) => {
      });

    this.form = new FormGroup({
      applicantSearch: new FormControl(null),
      attorneySearch: new FormControl(null),
      attorneyFirmSearch: new FormControl(null),
      attorneySearch_2: new FormControl(null),
      attorneyFirmSearch_2: new FormControl(null),
      insuranceSearch_2: new FormControl(null),
      reqFirstName: new FormControl("", [Validators.required]),
      reqMiddleName: new FormControl(""),
      reqLastName: new FormControl("", [Validators.required]),
      reqEmail: new FormControl("", [Validators.required, Validators.email]),
      reqParty: new FormControl("", [Validators.required]),
      reqDateRange_start: new FormControl(""),
      reqDateRange_end: new FormControl(""),
      organizationId: new FormControl(null, Validators.required),
      physician: new FormControl(null),
      panelNumber: new FormControl(null),
      medicalEvaluationType: new FormControl("Qualified Medical Evaluation"),
      evaluationType: new FormControl("Comprehensive"),
      encounterType: new FormControl("PQME"),
      //  dateOfAppointment: new FormControl(this.dateOfAppointment),
      //  dateOfAppointmentCall: new FormControl(new Date()),
      online: new FormControl(false),
      meetingLink: new FormControl(null),
      examinationAddress: new FormControl(null),
      examinationAddressName_2: new FormControl(null),
      examinationCity: new FormControl(null),
      examinationState: new FormControl(null),
      examinationZip: new FormControl(null),

      previousEncounter: new FormArray([]),
      check_previousEncounter: new FormControl(false),
      strikePanel: new FormControl(null),
      attorneyDemo: new FormControl(null),
      applicantName: new FormControl(null),
      applicantMiddleName: new FormControl(null),
      applicantLastName: new FormControl(null),
      dob: new FormControl(null),
      ssn: new FormControl(null),
      gender: new FormControl(null),
      address: new FormControl(null),
      address_2: new FormControl(null),
      city: new FormControl(""),
      state: new FormControl(""),
      zip: new FormControl(""),
      email: new FormControl(null, [Validators.email]),
      phone: new FormControl("None Provided", [this.phoneValidator]),
      altPhone: new FormControl("None Provided", [this.phoneValidator]),
      workPhone: new FormControl("None Provided", [this.phoneValidator]),
      jobtitle: new FormControl(""),
      modeOfTransmission: new FormControl("USPS"),
      // isEmail_sent: new FormControl(false),

      injuryDetails: new FormArray([this.createInjuryDetail()]),

      interpreter: new FormControl(false),
      language: new FormControl(""),
      vendor: new FormControl(""),
      vendorPhone: new FormControl(null, [this.phoneValidator]),

      unrepresented: new FormControl(false),
      firm: new FormControl(""),
      applicantAttorneyname: new FormControl(""),
      applicantAttorneymiddle: new FormControl(""),
      applicantAttorneylast: new FormControl(""),
      applicantAttorneyaddress: new FormControl(""),
      applicantAttorneyaddress_2: new FormControl(""),
      applicantAttorneyCity: new FormControl(""),
      applicantAttorneyState: new FormControl(""),
      applicantAttorneyZip: new FormControl(""),
      applicantAttorneyTelePhone: new FormControl("None Provided", [
        this.phoneValidator,
      ]),
      applicantAttorneyFax: new FormControl(""),
      applicantAttorneyEmail: new FormControl(null, [Validators.email]),
      applicantAttorneyAssitantEmail: new FormControl(null, [Validators.email]),
      applicantAttorneymodeOfTransmission: new FormControl("USPS"),

      defenseFirm: new FormControl(""),
      defenseName: new FormControl(""),
      defenseNamemiddle: new FormControl(""),
      defenseNamelast: new FormControl(""),
      defenseAddress: new FormControl(""),
      defenseAddress_2: new FormControl(""),
      defenseCity: new FormControl(""),
      defenseState: new FormControl(""),
      defenseZip: new FormControl(""),
      defensePhone: new FormControl("None Provided", [this.phoneValidator]),
      defenseFax: new FormControl(""),
      defenseEmail: new FormControl(null, [Validators.email]),
      defenseAssistantEmail: new FormControl(null, [Validators.email]),
      defensemodeOfTransmission: new FormControl("USPS"),
      employerSelfRepresented: new FormControl(false),
      // isEmail_sent_3: new FormControl(false),
      employer: new FormControl(""),
      employerPhone: new FormControl("None Provided", [this.phoneValidator]),
      employerFax: new FormControl(""),
      employerEmail: new FormControl(null, [Validators.email]),
      employerAddress: new FormControl(""),
      employerAddress_2: new FormControl(""),
      employerCity: new FormControl(""),
      employerState: new FormControl(""),
      employerZip: new FormControl(""),
      employermodeOfTransmission: new FormControl("USPS"),
      // isEmail_sent_4: new FormControl(false),

      insuranceCompany: new FormControl(""),
      insuranceCompanyPhone: new FormControl("None Provided"),
      payerId: new FormControl(null),
      insurancemodeOfTransmission: new FormControl("USPS"),

      // isEmail_sent_5: new FormControl(false),
      billingEmail: new FormControl(""),
      billingFax: new FormControl(""),
      billingAddress: new FormControl(""),
      billingReviewPhone: new FormControl(""),
      billingReviewEmail: new FormControl(""),
      adjuster: new FormControl(""),
      adjuster_middleName: new FormControl(""),
      adjuster_lastName: new FormControl(""),
      insuranceAddress: new FormControl(""),
      insuranceAddress_2: new FormControl(""),
      insuranceCity: new FormControl(""),
      insuranceState: new FormControl(""),
      insuranceZip: new FormControl(""),
      insurancePhone: new FormControl("None Provided", [this.phoneValidator]),
      insuranceFax: new FormControl(""),
      insuranceEmail: new FormControl(null, [Validators.email]),
      insuranceAssistant: new FormControl(null, [Validators.email]),
      insuranceClaimNo: new FormArray([new FormControl("")]),

      sibtf: new FormControl(false),
      subFund: new FormControl(""),
      subPhone: new FormControl(""),
      subFax: new FormControl(""),
      subAddress: new FormControl(""),
      subAddress_2: new FormControl(""),
      subCity: new FormControl(""),
      subState: new FormControl(""),
      subZip: new FormControl(""),
      subEmail: new FormControl(""),

      DeuAddress: new FormControl(""),
      DeuCity: new FormControl(""),
      DeuState: new FormControl(""),
      DeuZip: new FormControl(""),
    });

    this.form.get("sibtf")?.valueChanges.subscribe((value: boolean) => {
      this.form.get("encounterType")?.setValue(value ? "SIBTF" : "PQME");
    });

    this.fetchPhysicians();

    this.form.get("WCAB")?.setValue(this.wcabSelection);

    this.form.get("claimNumber")?.setValue(this.claimNumberSelection);

    this.form
      .get("examinationAddress")
      ?.valueChanges.subscribe((selectedExamination) => {
        this.getExaminationAddressDetails(selectedExamination);
      });

    this.updatePreviousEncounterLength();

    this.form.get("previousEncounter")?.valueChanges.subscribe(() => {
      this.updatePreviousEncounterLength();
    });

    this.form
      .get("check_previousEncounter")
      ?.valueChanges.subscribe((checked) => {
        if (checked) {
          this.form.get("evaluationType")?.setValue("Comprehensive");
        } else {
          this.form.get("evaluationType")?.setValue(null);
        }
      });

    this.watchUnrepresentedChange();
  }

  onLanguageChange(value: string) {
    if (value === "custom") {
      this.isCustomLanguage = true;
      this.customLanguageControl.setValue("");
      this.form.get("language")?.setValue("");
    } else {
      this.isCustomLanguage = false;
      this.form.get("language")?.setValue(value);
    }
  }

  updateCustomLanguage() {
    const customValue = this.customLanguageControl.value;

    if (!customValue || customValue.trim() === "") {
      this.isCustomLanguage = false;
      this.form.get("language")?.setValue("");
    } else {
      this.form.get("language")?.setValue(customValue);
    }
  }
  private zipSubscription: Subscription | undefined;

  watchUnrepresentedChange() {
    this.form.get("unrepresented")?.valueChanges.subscribe((unrep: boolean) => {
      if (unrep) {
        this.subscribeToZipChange(); // start watching zip changes
      } else {
        this.unsubscribeZipChange(); // stop watching zip changes
      }
    });
  }

  subscribeToZipChange() {
    console.log("Subscribing to zip changes...");
    this.unsubscribeZipChange(); // remove previous sub if any
  console.log("Subscribing to zip changes...",this.deuData);
    this.zipSubscription = this.form
      .get("zip")
      ?.valueChanges.subscribe((zipValue: string) => {
        if (!zipValue) return;

        const match = this.deuData.find(
          (item: any) => String(item.pin).trim() === String(zipValue).trim()
        );

        if (match) {
          this.form.patchValue({
            DeuAddress: match.address || "",
            DeuCity: match.city || "",
            DeuState: match.state || "",
            DeuZip: match.zip || "",
          });
        }
      });

    // Optional: apply immediately if ZIP already has value
    const currentZip = this.form.get("zip")?.value;
    if (currentZip) {
      const match = this.deuData.find(
        (item: any) => String(item.pin).trim() === String(currentZip).trim()
      );

      if (match) {
        this.form.patchValue({
          DeuAddress: match.address || "",
          DeuCity: match.city || "",
          DeuState: match.state || "",
          DeuZip: match.zip || "",
        });
      }
    }
  }

  unsubscribeZipChange() {
    this.zipSubscription?.unsubscribe();
    this.zipSubscription = undefined;
  }

  isPhoneInput = false;
  isCellPhoneInput = false;
  isWorkPhoneInput = false;

  getAllDeu() {
    const observer = {
      next: (response) => {
        this.deuData = response.data || [];
      },
      error: (error) => {
        console.error(error.message);
      },
    };

    this.calendarService.getAllDeuDetails().subscribe(observer);
  }

  onPhoneSelectionChange(value: string) {
    this.isCellPhoneInput = value === "Enter Phone";
    this.form
      .get("phone")
      ?.setValue(value === "Enter Phone" ? "" : "None Provided");
  }

  onAltPhoneSelectionChange(value: string) {
    this.isCellPhoneInput = value === "Enter Phone";
    this.form
      .get("altPhone")
      ?.setValue(value === "Enter Phone" ? "" : "None Provided");
  }

  onWorkPhoneSelectionChange(value: string) {
    this.isWorkPhoneInput = value === "Enter Phone";
    this.form
      .get("workPhone")
      ?.setValue(value === "Enter Phone" ? "" : "None Provided");
  }

  applicantAttorneyTelePhoneInput = false;

  onAttorneyPhoneSelectionChange(value: string) {
    if (value === "Enter Phone") {
      this.applicantAttorneyTelePhoneInput = true;
      this.form.get("applicantAttorneyTelePhone")?.setValue("");
      this.form
        .get("applicantAttorneyTelePhone")
        ?.setValidators([this.phoneValidator]);
    } else {
      this.applicantAttorneyTelePhoneInput = false;
      this.form.get("applicantAttorneyTelePhone")?.setValue("None Provided");
      this.form.get("applicantAttorneyTelePhone")?.clearValidators();
    }
    this.form.get("applicantAttorneyTelePhone")?.updateValueAndValidity();
  }

  defenseAttorneyTelePhoneInput = false;

  onDefenseSelectionChange(value: string) {
    if (value === "Enter Phone") {
      this.defenseAttorneyTelePhoneInput = true;
      this.form.get("defensePhone")?.setValue("");
      this.form
        .get("defensePhone")
        ?.setValidators([Validators.required, this.phoneValidator]);
    } else {
      this.defenseAttorneyTelePhoneInput = false;
      this.form.get("defensePhone")?.setValue("None Provided");
      this.form.get("defensePhone")?.setValidators([Validators.required]);
    }
    this.form.get("defensePhone")?.updateValueAndValidity();
  }

  employerPhoneInput = false;

  onEmployerPhoneSelectionChange(value: string) {
    if (value === "Enter Phone") {
      this.employerPhoneInput = true;
      this.form.get("employerPhone")?.setValue("");
      this.form.get("employerPhone")?.setValidators([this.phoneValidator]);
    } else {
      this.employerPhoneInput = false;
      this.form.get("employerPhone")?.setValue("None Provided");
      this.form.get("employerPhone")?.clearValidators();
    }
    this.form.get("employerPhone")?.updateValueAndValidity();
  }

  insuranceCompanyPhoneInput = false;

  oninsuranceCompanyPhoneSelectionChange(value: string) {
    if (value === "Enter Phone") {
      this.insuranceCompanyPhoneInput = true;
      this.form.get("insuranceCompanyPhone")?.setValue("");
      this.form
        .get("insuranceCompanyPhone")
        ?.setValidators([this.phoneValidator]);
    } else {
      this.insuranceCompanyPhoneInput = false;
      this.form.get("insuranceCompanyPhone")?.setValue("None Provided");
      this.form.get("insuranceCompanyPhone")?.clearValidators();
    }
    this.form.get("insuranceCompanyPhone")?.updateValueAndValidity();
  }

  insurancePhoneInput = false;

  onInsurancePhoneSelectionChange(value: string) {
    if (value === "Enter Phone") {
      this.insurancePhoneInput = true;
      this.form.get("insurancePhone")?.setValue("");
      this.form
        .get("insurancePhone")
        ?.setValidators([Validators.required, this.phoneValidator]);
    } else {
      this.insurancePhoneInput = false;
      this.form.get("insurancePhone")?.setValue("None Provided");
      this.form.get("insurancePhone")?.setValidators([Validators.required]);
    }
    this.form.get("insurancePhone")?.updateValueAndValidity();
  }
  //---------- Applicant, Attorney, defense , Insurance Data --------//

  updatePreviousEncounterLength() {
    const previousEncounter = this.form.get("previousEncounter") as FormArray;
    this.previousEncounterLength = previousEncounter?.length || 0;
  }

  updateEvaluationType(): void {
    const applicantName = this.form.get("applicantName")?.value;
    const applicantLastName = this.form.get("applicantLastName")?.value;
    const dob = this.form.get("dob")?.value;
    const physician = this.form.get("physician")?.value;

    if (applicantName && applicantLastName && dob && physician) {
      this.checkApplicantEncounter(
        applicantName,
        applicantLastName,
        dob,
        physician
      );
      this.checkApplicantPreviousEncounter(
        applicantName,
        applicantLastName,
        dob,
        physician
      );
    }
  }

  private formatPhoneNumber(value: string): string {
    const digits = value.replace(/\D/g, ""); // Remove non-digit characters
    const match = digits.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
    if (!match) return value;

    const [, areaCode, prefix, lineNumber] = match;
    let formatted = "";
    if (areaCode) formatted = `(${areaCode}`;
    if (areaCode && prefix) formatted += `) ${prefix}`;
    if (areaCode && prefix && lineNumber) formatted += `-${lineNumber}`;
    return formatted;
  }

  phoneValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) return null;

    if (value === "None Provided") {
      return null;
    }

    const phonePattern = /^\(\d{3}\) \d{3}-\d{4}$/;
    return phonePattern.test(value) ? null : { invalidPhone: true };
  }

  ssnValidator(control: FormControl) {
    const ssnPattern = /^\d{3}-\d{2}-\d{4}$|^\d{9}$|^XXX-XX-\d{4}$/;
    if (!control.value || ssnPattern.test(control.value)) {
      return null;
    }
    return { invalidSSN: true };
  }

  checkApplicantPreviousEncounter(
    applicantName: any,
    applicantLastName: any,
    dob: any,
    physician: any
  ) {
    this.calendarService
      .getPreviousEncounterData(
        applicantName,
        applicantLastName,
        dob,
        physician
      )
      .subscribe({
        next: (response: any) => {
          const previousEncounterData = response.data || [];

          while (this.previousEncounter.length < previousEncounterData.length) {
            this.addPreviousDetail();
          }
          while (this.previousEncounter.length > previousEncounterData.length) {
            this.previousEncounter.removeAt(this.previousEncounter.length - 1);
          }
          previousEncounterData.forEach((d, i) => {
            const formGroup = this.previousEncounter.at(i) as FormGroup;
            formGroup.patchValue({
              previousDate: d.dateOfAppointment,
              evaluationType: d.evaluationType,
            });
          });
        },
        error: (error) => {
          console.error("Error determining evaluation type:", error);
        },
      });
  }

  checkApplicantEncounter(
    applicantName: any,
    applicantLastName: any,
    dob: any,
    physician: any
  ) {
    this.calendarService
      .checkApplicantEncounter(applicantName, applicantLastName, dob, physician)
      .subscribe({
        next: (response: any) => {
          this.form.patchValue({
            evaluationType: response.type || "Comprehensive",
          });
        },
        error: (error) => {
          console.error("Error determining evaluation type:", error);
          this.form.patchValue({
            evaluationType: "Comprehensive",
          });
        },
      });
  }

  checkApplicantDateEncounter(
    applicantName: any,
    applicantLastName: any,
    dob: any,
    physician: any,
    date: any
  ) {
    this.calendarService
      .checkApplicantDateEncounter(
        applicantName,
        applicantLastName,
        dob,
        physician,
        date
      )
      .subscribe({
        next: (response: any) => {
          this.form.patchValue({
            evaluationType: response.type || "Comprehensive",
          });
        },
        error: (error) => {
          console.error("Error determining evaluation type:", error);
          this.form.patchValue({
            evaluationType: "Comprehensive",
          });
        },
      });
  }

  checkApplicantAppointmentDateEncounter(
    applicantName: any,
    applicantLastName: any,
    dob: any,
    physician: any,
    date: any
  ) {
    this.calendarService
      .checkApplicantAppointmentDateEncounter(
        applicantName,
        applicantLastName,
        dob,
        physician,
        date
      )
      .subscribe({
        next: (response: any) => {
          this.form.patchValue({
            evaluationType: response.type || "Comprehensive",
          });
        },
        error: (error) => {
          console.error("Error determining evaluation type:", error);
          this.form.patchValue({
            evaluationType: "Comprehensive",
          });
        },
      });
  }

  updateEvaluationType_Date(): void {
    const applicantName = this.form.get("applicantName")?.value;
    const applicantLastName = this.form.get("applicantLastName")?.value;
    const dob = this.form.get("dob")?.value;
    const physician = this.form.get("physician")?.value;
    const dateOfAppointment = this.form.get("dateOfAppointment")?.value;

    // Ensure all required values exist before making the API call
    if (
      applicantName &&
      applicantLastName &&
      dob &&
      physician &&
      dateOfAppointment
    ) {
      this.checkApplicantAppointmentDateEncounter(
        applicantName,
        applicantLastName,
        dob,
        physician,
        dateOfAppointment
      );
    }
  }

  evaluateBasedOnPreviousEncounters(): void {
    const applicantName = this.form.get("applicantName")?.value;
    const applicantLastName = this.form.get("applicantLastName")?.value;
    const dob = this.form.get("dob")?.value;
    const physician = this.form.get("physician")?.value;

    const previousEncounters = this.previousEncounter.controls.map(
      (control) => {
        const previousDate = control.get("previousDate")?.value;
        const evaluationType = control.get("evaluationType")?.value;
        return {
          previousDate: previousDate ? new Date(previousDate) : null,
          evaluationType,
        };
      }
    );

    const validEncounters = previousEncounters.filter(
      (encounter) => encounter.previousDate !== null
    );

    if (validEncounters.length === 0) {
      console.log(
        "No valid previous encounters, setting default evaluationType to Comprehensive."
      );
      this.form.patchValue({
        evaluationType: "Comprehensive",
      });
      return;
    }

    const nearestEncounter = validEncounters.reduce((nearest, current) => {
      const currentDifference = Math.abs(
        current.previousDate.getTime() - new Date().getTime()
      );
      const nearestDifference = Math.abs(
        nearest.previousDate.getTime() - new Date().getTime()
      );
      return currentDifference < nearestDifference ? current : nearest;
    });

    if (nearestEncounter.previousDate !== null) {
      this.checkApplicantDateEncounter(
        applicantName,
        applicantLastName,
        dob,
        physician,
        nearestEncounter.previousDate
      );
    } else {
      console.log(
        "No valid previous encounters, setting default evaluationType to Comprehensive."
      );
      this.form.patchValue({
        evaluationType: "Comprehensive",
      });
    }
  }

  getApplicants() {
    const observer = {
      next: (response) => {
        this.applicants = response.data || [];
        this.filteredApplicants = this.applicants;
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
      },
    };

    this.calendarService.getAllApplicants().subscribe(observer);
  }

  filterApplicants(query: string) {
    if (!this.applicants) return;
    this.form.patchValue({ applicantSearch: query });
    const lowerCaseQuery = query.toLowerCase();
    this.filteredApplicants = this.applicants.filter(
      (applicant) =>
        applicant.applicantName.toLowerCase().includes(lowerCaseQuery) ||
        applicant.patientID.toLowerCase().includes(lowerCaseQuery)
    );
  }

  getAttoryneyApplicants() {
    const observer = {
      next: (response) => {
        this.attorneys = response.data || [];
        this.filteredFirmAttorney = this.attorneys;
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
      },
    };

    this.calendarService.getAllAttorney().subscribe(observer);
  }

  filterAttorneyFirm(query: string) {
    if (!this.attorneys) return;
    this.form.patchValue({ attorneyFirmSearch: query });
    const lowerCaseQuery = query.toLowerCase();
    this.filteredFirmAttorney = this.attorneys.filter((data) =>
      data.firm.toLowerCase().includes(lowerCaseQuery)
    );
  }

  onApplicantAttorneyFirmSelected(attorney: string) {
    this.form.patchValue({ attorneyFirmSearch: attorney });
    const lowerCaseQuery = attorney.toLowerCase();
    this.filteredApplicantAttorney = this.attorneys.filter((data) =>
      data.firm.toLowerCase().includes(lowerCaseQuery)
    );
  }
  onDefenseAttorneyFirmSelected(attorney: string) {
    this.form.patchValue({ attorneyFirmSearch_2: attorney });
    const lowerCaseQuery = attorney.toLowerCase();
    this.filtereddefenseAttorney = this.attorneys.filter((data) =>
      data.firm.toLowerCase().includes(lowerCaseQuery)
    );
  }
  filterAttorneydefense(query: string) {
    if (!this.attorneys) return;
    this.form.patchValue({ attorneyFirmSearch_2: query });
    const lowerCaseQuery = query.toLowerCase();
    this.filteredFirmAttorney = this.attorneys.filter((data) =>
      data.firm.toLowerCase().includes(lowerCaseQuery)
    );
  }

  onApplicantSelected(applicant: any) {
    const decryptedSSN = applicant.ssn;
    const last4Digits = decryptedSSN.slice(-4);
    this.form.patchValue({
      applicantName: applicant.applicantName,
      applicantMiddleName: applicant.applicantMiddleName,
      applicantLastName: applicant.applicantLastName,
      address: applicant.address,
      address_2: applicant.address_2,
      city: applicant.city,
      state: applicant.state,
      zip: applicant.zip,
      dob: applicant.dob,
      email: applicant.email,
      gender: applicant.gender,
      phone: applicant.phone,
      altPhone: applicant.altPhone,
      workPhone: applicant.workPhone,
      ssn: applicant.ssn,
      jobtitle: applicant.jobtitle,
      isEmail_sent: applicant.isEmail_sent,
    });
    this.form.patchValue({ applicantSearch: applicant.applicantName });
    this.applicantDigitalService = applicant.applicantDigitalService;
    this.isPhoneInput = applicant.phone !== "None Provided";
    this.isCellPhoneInput = applicant.altPhone !== "None Provided";
    this.isWorkPhoneInput = applicant.workPhone !== "None Provided";
  }

  onApplicantAttorneySelected(attorney: any) {
    if (attorney) {
      this.form.patchValue({
        firm: attorney.firm,
        applicantAttorneyname: attorney.Attorneyname,
        applicantAttorneymiddle: attorney.m_name,
        applicantAttorneylast: attorney.l_name,
        applicantAttorneyaddress: attorney.Attorneyaddress,
        applicantAttorneyaddress_2: attorney.Attorneyaddress_2,
        applicantAttorneyCity: attorney.AttorneyCity,
        applicantAttorneyState: attorney.AttorneyState,
        applicantAttorneyZip: attorney.AttorneyZip,
        applicantAttorneyTelePhone: attorney.AttorneyTelePhone,
        applicantAttorneyFax: attorney.AttorneyFax,
        applicantAttorneyEmail: attorney.AttorneyEmail,
        applicantAttorneyAssitantEmail: attorney.AttorneyAssitantEmail,
        applicantAttorneymodeOfTransmission: attorney.modeOfTransmission,
        isEmail_sent_2: attorney.isEmail_sent_2,
      });
      this.form.setValue({ attorneySearch: attorney.f_name });
      this.applicantAttorneyDigitalService = attorney.AttorneyDigitalService;
      this.applicantAttorneyTelePhoneInput =
        attorney.AttorneyTelePhone !== "None Provided";
    }
  }

  compareAttorney(a: any, b: any) {
    return a && b ? a.f_name === b.f_name : a === b;
  }

  ondefenseAttorneySelected(attorney: any) {
    this.form.patchValue({
      defenseFirm: attorney.firm,
      defenseName: attorney.Attorneyname,
      defenseNamemiddle: attorney.m_name,
      defenseNamelast: attorney.l_name,
      defenseAddress: attorney.Attorneyaddress,
      defenseAddress_2: attorney.Attorneyaddress_2,
      defenseCity: attorney.AttorneyCity,
      defenseState: attorney.AttorneyState,
      defenseZip: attorney.AttorneyZip,
      defensePhone: attorney.AttorneyTelePhone,
      defenseFax: attorney.AttorneyFax,
      defenseEmail: attorney.AttorneyEmail,
      defenseAssistantEmail: attorney.AttorneyAssitantEmail,
      defensemodeOfTransmission: attorney.modeOfTransmission,
      isEmail_sent_3: attorney.isEmail_sent_3,
    });
    (this.defenseDigitalService = attorney.AttorneyDigitalService),
      this.form.setValue({ attorneySearch_2: attorney.f_name });
    this.defenseAttorneyTelePhoneInput =
      attorney.AttorneyTelePhone !== "None Provided";
  }

  filterInsuranceByEmployer(employer: string) {
    if (!employer) {
      this.filteredInsurance = this.insuracneCompany;
      return;
    }
    this.filteredInsurance = this.insuracneCompany.filter((company) =>
      company.employers?.includes(employer)
    );
  }

  getInsurance() {
    const observer = {
      next: (response) => {
        this.insuracneCompany = response.data || [];
        this.filteredInsurance = this.insuracneCompany;
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
      },
    };

    this.calendarService.getInsuranceComp().subscribe(observer);
  }

  filterInsurance(query: string) {
    if (!this.insuracneCompany) return;
    this.form.patchValue({ insuranceSearch_2: query });
    const lowerCaseQuery = query.toLowerCase();
    this.filteredInsurance = this.insuracneCompany.filter((data) =>
      data.insuranceCompany.toLowerCase().includes(lowerCaseQuery)
    );
  }

  onInsuranceSelected(data: any) {
    this.form.patchValue({
      insuranceCompany: data.insuranceCompany,
      insuranceCompanyPhone: data.insuranceCompanyPhone,
      payerId: data.payerId,
      insurancemodeOfTransmission: data.insurancemodeOfTransmission,
      billingEmail: data.billingEmail,
      billingFax: data.billingFax || "",
      billingAddress: data.billingAddress,
      billingReviewPhone: data.billingReviewPhone,
      billingReviewEmail: data.billingReviewEmail,
      adjuster: data.adjuster,
      adjuster_middleName: data.adjuster_middleName,
      adjuster_lastName: data.adjuster_lastName,
      insuranceAddress: data.insuranceAddress,
      insuranceAddress_2: data.insuranceAddress_2,
      insuranceCity: data.insuranceCity,
      insuranceState: data.insuranceState,
      insuranceZip: data.insuranceZip,
      insurancePhone: data.insurancePhone,
      insuranceFax: data.insuranceFax,
      insuranceEmail: data.insuranceEmail,
      insuranceAssistant: data.insuranceAssistant,
      // insuranceDigitalService: data.insuranceDigitalService,
      isEmail_sent_5: data.isEmail_sent_5,
    });

    this.form.patchValue({ insuranceSearch_2: data.insuranceCompany });
    this.insuranceDigitalService = data.insuranceDigitalService;
  }

  //------------------------ END ---------------------- //

  cleanData(data: any): any {
    const cleanedData: any = {};
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        cleanedData[key] = data[key] == null ? "" : data[key];
      }
    }
    return cleanedData;
  }

  //------------- get physician data -----------------//

  onOrganizationChange(): void {
    this.form.patchValue({ physician: null, examinationAddress: null, examinationCity: null, examinationState: null, examinationZip: null });
    this.clinics = [];
    this.filterOrganizationPhysicians();
  }

  private filterOrganizationPhysicians(): void {
    this.physicians = this.organizationPhysicians.filter(p => p.organizationId === this.form.get("organizationId")?.value);
  }

  fetchPhysicians() {
    const sub = this.demoService.getPhysicians().subscribe((response) => {
      this.organizationPhysicians = response.data || [];
      this.organizations = [...new Map(this.organizationPhysicians.filter(p => p.organizationId && p.organizationActive !== false).map(p => [p.organizationId, { _id: p.organizationId, name: p.organizationName, code: p.organizationCode, active: true } as OrganizationOption])).values()];
      this.filterOrganizationPhysicians();
    });
    this.subscriptions.push(sub);

    this.isLoading = false;
  }
  //------------------------ END ---------------------- //

  onWCABChange(index: number, value: string) {
    if (value === "") {
      this.injuryDetails.at(index).patchValue({ isCustomWCAB: true });
    } else {
      this.injuryDetails
        .at(index)
        .patchValue({ isCustomWCAB: false, WCAB: value });
    }
  }

  onClaimNumberChange(index: number, value: string) {
    if (value === "") {
      this.injuryDetails.at(index).patchValue({ isCustomClaimNumber: true });
    } else {
      this.injuryDetails
        .at(index)
        .patchValue({ isCustomClaimNumber: false, claimNumber: value });
    }
  }

  onBlur(): void {
    if (!this.wcabSelection) {
      this.wcabSelection = "None Provided";
      this.isCustomWCAB = false;
      this.form.get("WCAB")?.setValue(this.wcabSelection);
    }
  }

  onClaimNumberBlur(): void {
    if (!this.claimNumberSelection) {
      this.claimNumberSelection = "None Provided";
      this.isCustomClaimNumber = false;
      this.form.get("claimNumber")?.setValue(this.claimNumberSelection);
    }
  }

  //--------------- insurrance claim ------------------//

  get insuranceClaimNoArray(): FormArray {
    return this.form.get("insuranceClaimNo") as FormArray;
  }

  addClaimNumber(): void {
    this.insuranceClaimNoArray.push(new FormControl(""));
    // this.insuranceClaimNoArray.push(new FormControl("", Validators.required));
  }

  removeClaimNumber(index: number): void {
    this.insuranceClaimNoArray.removeAt(index);
  }

  //------------------ END ---------------------------//

  //----------------- injuryDetails ------------------//

  createInjuryDetail(): FormGroup {
    return new FormGroup({
      injuryType: new FormControl("specific"),
      specificDate: new FormControl(null),
      start: new FormControl(null),
      end: new FormControl(null),
      injuryBodyPart: new FormControl(null),
      WCAB: new FormControl("None Provided"),
      claimNumber: new FormControl("None Provided"),
      isCustomWCAB: new FormControl(false),
      isCustomClaimNumber: new FormControl(false),
    });
  }

  get injuryDetails(): FormArray {
    return this.form.get("injuryDetails") as FormArray;
  }

  addInjuryDetail() {
    this.injuryDetails.push(this.createInjuryDetail());
  }

  onInjuryTypeChange(index: number) {
    const detail = this.injuryDetails.at(index);
    const injuryType = detail.get("injuryType").value;

    if (injuryType === "specific") {
      detail.get("specificDate")?.setValue(null);
      detail.get("start")?.setValue(null);
      detail.get("end")?.setValue(null);
    } else if (injuryType === "cumulative") {
      detail.get("specificDate")?.setValue(null);
    }
  }

  removeInjuryDetail(index: number) {
    this.injuryDetails.removeAt(index);
  }

  //-------------------- END -------------------//

  // Previous Encounter
  createPreviousDetail(): FormGroup {
    return new FormGroup({
      previousDate: new FormControl(""),
      evaluationType: new FormControl(""),
    });
  }

  get previousEncounter(): FormArray {
    return this.form.get("previousEncounter") as FormArray;
  }

  addPreviousDetail() {
    this.previousEncounter.push(this.createPreviousDetail());
  }

  removePreviousDetail(index: number) {
    this.previousEncounter.removeAt(index);
  }

  capitalizeFirstLetter(controlName: string): void {
    const control = this.form.get(controlName);
    if (control) {
      let value = control.value || "";

      value = value.replace(/[^a-zA-Z'-. ]/g, "");

      const formattedValue = value.replace(/\b\w/g, (char) =>
        char.toUpperCase()
      );

      control.setValue(formattedValue, { emitEvent: false });
    }
  }

  capitalizeFirmName(controlName: string): void {
    const control = this.form.get(controlName);
    if (control) {
      let value = control.value || "";

      // Allow only letters, apostrophe ('), hyphen (-), period (.), ampersand (&), comma (,), forward slash (/), and parentheses (())
      value = value.replace(/[^a-zA-Z'-.&,/() ]/g, "");

      // Capitalize the first letter of each word
      const formattedValue = value.replace(/\b\w/g, (char) =>
        char.toUpperCase()
      );

      // Update the form control without emitting an event
      control.setValue(formattedValue, { emitEvent: false });
    }
  }
  restrictNonNumeric(event: ClipboardEvent | KeyboardEvent): void {
    if (event instanceof ClipboardEvent) {
      // Handle paste event
      event.preventDefault();
      const clipboardData = event.clipboardData?.getData("text") || "";
      const sanitizedValue = clipboardData.replace(/\D/g, ""); // Remove non-numeric characters

      if (sanitizedValue) {
        document.execCommand("insertText", false, sanitizedValue);
      }
    } else if (event instanceof KeyboardEvent) {
      // Handle keypress event
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }
    }
  }

  restrictNonAlphanumeric(event: KeyboardEvent): void {
    const key = event.key;

    // Allow only letters (A-Z, a-z) and numbers (0-9)
    if (!/^[a-zA-Z0-9]$/.test(key)) {
      event.preventDefault(); // Block special characters
    }
  }

  onPhysicianChange(physicianId: string): void {
    if (physicianId) {
      this.form.patchValue({
        examinationAddress: null,
        examinationCity: null,
        examinationState: null,
        examinationZip: null,
      });

      this.fetchPhysicianClinic(physicianId);
    } else {
      this.clinics = [];
    }
  }

  fetchPhysicianClinic(physicianId: any) {
    this.calendarService
      .getPhysicianExaminationAddressById(physicianId)
      .subscribe((response) => {
        this.clinics = response.data || [];
      });
  }

  getExaminationAddressDetails(selectedExamination: any) {
    if (!this.clinics || !Array.isArray(this.clinics)) {
      return;
    }

    if (selectedExamination) {
      const selectedClinic = this.clinics.find(
        (clinic) => clinic.locationId._id === selectedExamination
      );

      if (selectedClinic) {
        this.form.patchValue({
          examinationCity: selectedClinic.locationId.city || "",
          examinationState: selectedClinic.locationId.state || "",
          examinationZip: selectedClinic.locationId.zip || "",
        });
      } else {
        console.warn("No matching clinic found for the selected examination.");
      }
    } else {
      this.form.patchValue({
        examinationCity: null,
        examinationState: null,
        examinationZip: null,
      });
    }
  }

  openBodyPartsDialog(index: number) {
    const currentBodyParts = this.injuryDetails.at(index).get('injuryBodyPart')?.value || [];
    
    const dialogRef = this.dialog.open(BodyPartsComponent, {
      width: "950px",
      panelClass: "custom-OpenPdfDialog",
      data: { selectedParts: new Set(currentBodyParts) },
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      // result may be a Set or an Array or undefined (user cancelled)
      if (result !== undefined) {
        const setResult = result instanceof Set ? result : new Set(result || []);
        const bodyPartsArray = Array.from(setResult);
        // Always update the control (including empty array) so UI & form stay in sync
        this.injuryDetails.at(index).patchValue({ injuryBodyPart: bodyPartsArray });
      }
    });
  }

  removeChip(index: number, part: string): void {
    const currentParts = this.injuryDetails
      .at(index)
      .get("injuryBodyPart").value;
    const partIndex = currentParts.indexOf(part);
    if (partIndex >= 0) {
      currentParts.splice(partIndex, 1);
      this.injuryDetails.at(index).patchValue({ injuryBodyPart: currentParts });
    }
  }

  selectedStrikePanelFiles: File[] = [];
  selectedAttorneyDemoFiles: File[] = [];

  onFileSelected(event: any, type: string) {
    const files: FileList = event.target.files;
    for (let i = 0; i < files.length; i++) {
      if (type === "strikePanel") {
        this.selectedStrikePanelFiles.push(files[i]);
        this.form.patchValue({ strikePanel: this.selectedStrikePanelFiles });
      } else if (type === "attorneyDemo") {
        this.selectedAttorneyDemoFiles.push(files[i]);
        this.form.patchValue({ attorneyDemo: this.selectedAttorneyDemoFiles });
      }
    }
    if (this.fileInputStrikePanel) {
      this.fileInputStrikePanel.nativeElement.value = "";
    }
    if (this.fileInputAttorneyDemos) {
      this.fileInputAttorneyDemos.nativeElement.value = "";
    }
  }

  removeFile(index: number, type: string) {
    if (type === "strikePanel") {
      this.selectedStrikePanelFiles.splice(index, 1);
      this.form.patchValue({ strikePanel: this.selectedStrikePanelFiles });
    } else if (type === "attorneyDemo") {
      this.selectedAttorneyDemoFiles.splice(index, 1);
      this.form.patchValue({ attorneyDemo: this.selectedAttorneyDemoFiles });
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }
  onDragOver_2(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver_2 = true;
  }

  onDragLeave_2(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver_2 = false;
  }

  onDrop(event: DragEvent, type: string) {
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer?.files) {
      for (let i = 0; i < event.dataTransfer.files.length; i++) {
        if (type === "strikePanel") {
          this.isDragOver = false;
          if (this.isValidFileTypeForStrike(event.dataTransfer.files[i])) {
            this.selectedStrikePanelFiles.push(event.dataTransfer.files[i]);
            this.form.patchValue({
              strikePanel: this.selectedStrikePanelFiles,
            });
          } else {
            this.toastr.error(
              "Only .pdf, .png, .jpg, .jpeg, .doc, .docx files are allowed!"
            );
          }
        } else if (type === "attorneyDemo") {
          this.isDragOver_2 = false;
          if (this.isValidFileTypeForAttorney(event.dataTransfer.files[i])) {
            this.selectedAttorneyDemoFiles.push(event.dataTransfer.files[i]);
            this.form.patchValue({
              attorneyDemo: this.selectedAttorneyDemoFiles,
            });
          } else {
            this.toastr.error("Only .doc .docx and pdf files are allowed!");
          }
        }
      }
    }
  }

  isValidFileTypeForStrike(file: File): boolean {
    const validExtensions = [".pdf", ".png", ".jpg", ".jpeg", ".doc", ".docx"];
    const fileExtension = file.name.split(".").pop()?.toLowerCase();
    return fileExtension
      ? validExtensions.includes(`.${fileExtension}`)
      : false;
  }

  isValidFileTypeForAttorney(file: File): boolean {
    const validExtensions = [".pdf", ".doc", ".docx"];
    const fileExtension = file.name.split(".").pop()?.toLowerCase();
    return fileExtension
      ? validExtensions.includes(`.${fileExtension}`)
      : false;
  }

  fileURL: string = "https://drive.google.com/file/d/";

  viewFile(fileId: string): string {
    return this.googleUrlService.getDriveUrl(fileId, 'view');
  }

  setDraft(draft: any) {
    this.isDraft = draft;
  }

  formatDateOnly(d: any): string {
    if (!d) return "";
    const date = d instanceof Date ? d : new Date(d);
    if (isNaN(date.getTime())) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }


//     formatDateOnly(d: any): string {
//   if (!d) return "";
//   const date = d instanceof Date ? d : new Date(d);
//   if (isNaN(date.getTime())) return "";

//   // Step 1: Convert to UTC
//   const utc = date.getTime() + (date.getTimezoneOffset() * 60000);

//   // Step 2: Convert to PST (UTC - 8 hours)
//   const pstDate = new Date(utc - (8 * 60 * 60000));

//   const year = pstDate.getFullYear();
//   const month = String(pstDate.getMonth() + 1).padStart(2, "0");
//   const day = String(pstDate.getDate()).padStart(2, "0");

//   return `${year}-${month}-${day}`;
// }

  buildEncounterData() {
    return {
      reqFirstName: this.form.value.reqFirstName,
      reqMiddleName: this.form.value.reqMiddleName,
      reqLastName: this.form.value.reqLastName,
      reqEmail: this.form.value.reqEmail,
      reqParty: this.form.value.reqParty,
      reqDateRange_start: this.form.value.reqDateRange_start,
      reqDateRange_end: this.form.value.reqDateRange_end,
      organizationId: this.form.get("organizationId")?.value,
      physician: this.form.value.physician,
      panelNumber: this.form.value.panelNumber,
      medicalEvaluationType: this.form.value.medicalEvaluationType,
      evaluationType: this.form.value.evaluationType,
      encounterType: this.form.value.encounterType,
      dateOfAppointment: this.form.value.dateOfAppointment,
      dateOfAppointmentCall: 
        this.form.value.dateOfAppointmentCall
      ,
      online: this.form.value.online,
      meetingLink: this.form.value.meetingLink,
      examinationAddress: this.form.value.examinationAddress,
      examinationCity: this.form.value.examinationCity,
      examinationState: this.form.value.examinationState,
      examinationZip: this.form.value.examinationZip,
      previousEncounter: this.form.value.previousEncounter,
      applicantName: this.form.value.applicantName,
      applicantMiddleName: this.form.value.applicantMiddleName,
      applicantLastName: this.form.value.applicantLastName,
      dob: this.form.value.dob,
      ssn: this.form.value.ssn,
      gender: this.form.value.gender,
      address: this.form.value.address,
      address_2: this.form.value.address_2,
      city: this.form.value.city,
      state: this.form.value.state,
      zip: this.form.value.zip,
      email: this.form.value.email,
      phone: this.form.value.phone,
      altPhone: this.form.value.altPhone,
      workPhone: this.form.value.workPhone,
      jobtitle: this.form.value.jobtitle,
      modeOfTransmission: this.form.value.modeOfTransmission,
      // injuryDetails: this.form.value.injuryDetails,
      injuryDetails: this.form.value.injuryDetails.map((detail) => ({
        ...detail,
        specificDate: detail.specificDate,
        start: detail.start,
        end: detail.end,
      })),
      interpreter: this.form.value.interpreter,
      language: this.form.value.language,
      vendor: this.form.value.vendor,
      vendorPhone: this.form.value.vendorPhone,

      unrepresented: this.form.value.unrepresented,
      firm: this.form.value.firm,
      applicantAttorneyname: this.form.value.applicantAttorneyname,
      applicantAttorneymiddle: this.form.value.applicantAttorneymiddle,
      applicantAttorneylast: this.form.value.applicantAttorneylast,

      applicantAttorneyaddress: this.form.value.applicantAttorneyaddress,
      applicantAttorneyaddress_2: this.form.value.applicantAttorneyaddress_2,
      applicantAttorneyCity: this.form.value.applicantAttorneyCity,
      applicantAttorneyState: this.form.value.applicantAttorneyState,
      applicantAttorneyZip: this.form.value.applicantAttorneyZip,
      applicantAttorneyTelePhone: this.form.value.applicantAttorneyTelePhone,
      applicantAttorneyFax: this.form.value.applicantAttorneyFax,
      applicantAttorneyEmail: this.form.value.applicantAttorneyEmail,
      applicantAttorneyAssitantEmail:
        this.form.value.applicantAttorneyAssitantEmail,
      applicantAttorneymodeOfTransmission:
        this.form.value.applicantAttorneymodeOfTransmission,

      DeuAddress: this.form.value.DeuAddress,
      DeuCity: this.form.value.DeuCity,
      DeuState: this.form.value.DeuState,
      DeuZip: this.form.value.DeuZip,

      defenseFirm: this.form.value.defenseFirm,
      defenseName: this.form.value.defenseName,
      defenseNamemiddle: this.form.value.defenseNamemiddle,
      defenseNamelast: this.form.value.defenseNamelast,
      defenseAddress: this.form.value.defenseAddress,
      defenseAddress_2: this.form.value.defenseAddress_2,
      defenseCity: this.form.value.defenseCity,
      defenseState: this.form.value.defenseState,
      defenseZip: this.form.value.defenseZip,
      defensePhone: this.form.value.defensePhone,
      defenseFax: this.form.value.defenseFax,
      defenseEmail: this.form.value.defenseEmail,
      defenseAssistantEmail: this.form.value.defenseAssistantEmail,
      defensemodeOfTransmission: this.form.value.defensemodeOfTransmission,

      employerSelfRepresented: this.form.value.employerSelfRepresented,
      employer: this.form.value.employer,
      employerPhone: this.form.value.employerPhone,
      employerFax: this.form.value.employerFax,
      employerEmail: this.form.value.employerEmail,
      employerAddress: this.form.value.employerAddress,
      employerAddress_2: this.form.value.employerAddress_2,
      employerCity: this.form.value.employerCity,
      employerState: this.form.value.employerState,
      employerZip: this.form.value.employerZip,
      employermodeOfTransmission: this.form.value.employermodeOfTransmission,

      insuranceCompany: this.form.value.insuranceCompany,
      insuranceCompanyPhone: this.form.value.insuranceCompanyPhone,
      payerId: this.form.value.payerId,
      insurancemodeOfTransmission: this.form.value.insurancemodeOfTransmission,
      billingEmail: this.form.value.billingEmail,
      billingFax: this.form.value.billingFax,
      billingAddress: this.form.value.billingAddress,
      billingReviewPhone: this.form.value.billingReviewPhone,
      billingReviewEmail: this.form.value.billingReviewEmail,
      adjuster: this.form.value.adjuster,
      adjuster_middleName: this.form.value.adjuster_middleName,
      adjuster_lastName: this.form.value.adjuster_lastName,
      insuranceAddress: this.form.value.insuranceAddress,
      insuranceAddress_2: this.form.value.insuranceAddress_2,
      insuranceCity: this.form.value.insuranceCity,
      insuranceState: this.form.value.insuranceState,
      insuranceZip: this.form.value.insuranceZip,
      insurancePhone: this.form.value.insurancePhone,
      insuranceFax: this.form.value.insuranceFax,
      insuranceEmail: this.form.value.insuranceEmail,
      insuranceAssistant: this.form.value.insuranceAssistant,
      insuranceClaimNo: this.form.value.insuranceClaimNo,

      sibtf: this.form.value.sibtf,
      subFund: this.form.value.subFund,
      subPhone: this.form.value.subPhone,
      subFax: this.form.value.subFax,
      subAddress: this.form.value.subAddress,
      subAddress_2: this.form.value.subAddress_2,
      subCity: this.form.value.subCity,
      subState: this.form.value.subState,
      subZip: this.form.value.subZip,
      subEmail: this.form.value.subEmail,
    };
  }

  onSave() {
    if (this.form.invalid) {
      this.toastr.error("Please fill all required fields.");
      return;
    }

    const encounterData = this.buildEncounterData();

    this.isSubmitting = true;

    const encounterObservable = this.demoService.createEncounter(
      encounterData,
      this.selectedStrikePanelFiles,
      this.selectedAttorneyDemoFiles
    );

    encounterObservable.subscribe({
      next: (responseData) => {
        this.isSubmitting = false;
        this.toastr.success(`Data submitted successfully`);
      },
      error: (error) => {
        this.isSubmitting = false;
        // this.toastr.error(`Failed to submit request`, "Error", {
        //   timeOut: 3000,
        //   closeButton: true,
        // });
      },
      complete: () => {
        this.isSubmitting = false;
        this.closeDialog();
        this.router.navigate(["/thank_you_for_request_form"]);
      },
    });
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  back() {
    this.location.back();
  }

  ngOnDestroy() {
    this.authStatusSub.unsubscribe();
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.insuracneCompany = [];
    this.clinics = [];
    this.applicants = [];
    this.attorneys = [];
    this.filteredInsurance = [];
    this.filteredApplicants = [];
    this.filteredApplicantAttorney = [];
    this.physicians = [];
    this.filteredFirmAttorney = [];
    this.filtereddefenseAttorney = [];
  }
}
